import { useInfiniteQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { getMessageGroupMessages } from "../actions/messageGroups.actions";
import { messageGroupsQueryKeys } from "../messageGroups.queryKeys";

export const useMessageGroupMessagesQuery = ({
  groupUid,
  companyId,
  pageSize = 20,
  enabled = true,
}: {
  groupUid?: string;
  companyId?: number | string | null;
  pageSize?: number;
  enabled?: boolean;
}) => {
  const token = sessionStorage.getItem("token");
  const activeCompanyId = useSelector((state: any) => state.userState.activeCompanyId);
  const effectiveCompanyId = companyId ?? activeCompanyId;

  const queryOptions = useMemo(
    () => ({
      queryKey: messageGroupsQueryKeys.messages(effectiveCompanyId, groupUid),
      queryFn: async ({ pageParam = 1 }) =>
        getMessageGroupMessages(token, groupUid as string, { page: pageParam as number, pageSize, order: "DESC", companyId: effectiveCompanyId }),
      getNextPageParam: (lastPage: any) => {
        const page = Number(lastPage?.page);
        const total = Number(lastPage?.totalPages);
        if (!page || !total || page >= total) return undefined;
        return page + 1;
      },
      initialPageParam: 1,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      staleTime: 0,
      gcTime: 0,
      enabled: Boolean(token && effectiveCompanyId && groupUid) && enabled,
    }),
    [token, effectiveCompanyId, groupUid, pageSize, enabled],
  );

  const messagesQuery = useInfiniteQuery(queryOptions);

  return { messagesQuery, activeCompanyId: effectiveCompanyId };
};
